export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const CHANNEL_URL_REGEX =
  /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

export const CONTAINER_REGISTRY_URI_PATTERN = {
  ECR: /^[0-9]+\.dkr\.ecr\.[a-zA-Z0-9-]+\.amazonaws\.com\/?$/,
  AZURE_CONTAINER_REGISTRY: /^https:\/\/[a-zA-Z0-9-]+\.azurecr\.io\/?$/,
  GOOGLE_ARTIFACT_REGISTRY:
    /^https:\/\/[a-zA-Z0-9-]+\-docker\.pkg\.dev\/[a-zA-Z0-9-]+\/[a-zA-Z0-9-]+\/?$/,
  GOOGLE_CONTAINER_REGISTRY: /^https:\/\/[a-zA-Z0-9-]+\.gcr\.io\/?$/,
  NEXUS: /^https:\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+(:\d+)?(\/[^\s]*)?$/,
  JFROG: /^https:\/\/[a-zA-Z0-9-]+\.jfrog\.io\/?$/,
  DOCKER_HUB: /^https:\/\/index\.docker\.io\/?.*$/,
  OTHERS: /^(https?):\/\/[^\s$.?#].[^\s]*$/,
};
